<button class="primary-btn">
  <img
    *ngIf="loader"
    class="btn-loader"
    src="../../../../assets/loaders/tail-spin.svg"
  />
  <fa-icon *ngIf="!loader" [icon]="buttonIcon"></fa-icon>{{ buttonTitle }}
</button>
